import React, { useEffect, useState } from "react";
import { useTranslation } from '../redux/TranslationHelper';

function formatDate(date) {
  return date.toISOString().slice(0, 10);
}

function formatKoreanDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString("ko-KR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

const TempTwo = ({ isPreview }) => {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const toDate = new Date();
    const fromDate = new Date();
    fromDate.setDate(toDate.getDate() - 30);

    const from = formatDate(fromDate);
    const to = formatDate(toDate);

    fetch(
      `https://local.nesem.io.kr/api/asset-transactions/summary/me?from=${from}&to=${to}`
    )
      .then((res) => res.json())
      .then((data) => {
        setItems(data.items || []);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>{t("Loading...")}</div>;

  return (
    <div style={{
      maxWidth: '80VW',
      margin: "40px auto",
      background: "#fff",
      borderRadius: 12,
      boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
      padding: 24,
      fontFamily: "inherit"
    }}>
      <h2 style={{marginBottom: 24, fontWeight: 700, fontSize: 22, color: "#222"}}>{t("Last 1 month summary")}</h2>
      <table style={{width: "100%", borderCollapse: "collapse"}}>
        <thead>
          <tr style={{background: "#f7f7f7"}}>
            <th style={{padding: "10px 0", fontWeight: 600, color: "#555"}}>{t("Date")}</th>
            <th style={{padding: "10px 0", fontWeight: 600, color: "#555"}}>{t("Category")}</th>
            <th style={{padding: "10px 0", fontWeight: 600, color: "#555"}}>{t("Amount")}</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 && (
            <tr>
              <td colSpan={3} style={{padding: "24px 0", color: "#aaa", textAlign: "center"}}>{t("No data")}</td>
            </tr>
          )}
          {items.map((item) => (
            <tr key={item.id} style={{borderBottom: "1px solid #eee"}}>
              <td style={{padding: "10px 0", color: "#333"}}>{formatKoreanDate(item.summaryDate)}</td>
              <td style={{padding: "10px 0", color: "#333"}}>{item.extraPresetStep?.name}</td>
              <td style={{padding: "10px 0", color: "#333", textAlign: "right"}}>{item.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TempTwo; 